import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OrgInitService } from './org-init.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Global } from '../Shared/global';

@Injectable({
  providedIn: 'root'
})
export class OrgInitGuard implements CanActivate {
  private initialized = false;
  private initPromise: Promise<boolean | UrlTree> | null = null;

  constructor(
    private orgInitService: OrgInitService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean {
    Global.Log('[OrgInitGuard] canActivate called for route:', state.url);
    // Only initialize once
    if (!this.initialized) {
      if (!this.initPromise) {
        this.initPromise = this.performInitialization();
      }
      //return this.initPromise.then(() => {
      //  Global.Log('[OrgInitGuard] Initialization complete, allowing navigation');
      //  return true;
      //});
      return this.initPromise;
    }

    return true;
  }

  private performInitialization(): Promise<boolean | UrlTree> {
    return new Promise((resolve) => {
      Global.Log('[OrgInitGuard] Starting organization validation...');
      this.orgInitService.initializeOrgValidation().subscribe({
        next: (result) => {
          Global.Log('[OrgInitGuard] Org validation result:', result);
          this.initialized = true;

          if (result.success) {
            Global.Log('[OrgInitGuard] Organization validated');
            resolve(true);
          } else {
            Global.Log('[OrgInitGuard] Redirecting to org-input');
            resolve(this.router.createUrlTree(['/org-input']));
          }
        },
        error: (error) => {
          Global.LogError('[OrgInitGuard] Error:', error);
          this.initialized = true;
          resolve(this.router.createUrlTree(['/org-input']));
        }
      });
    });
  }
}
